/* eslint-disable @typescript-eslint/ban-types */
export var toString = function (x) { return Object.prototype.toString.call(x); };
export function isObject(what) {
    return typeof what === 'object' && what !== null && !isArray(what);
}
export function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
export function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
export function isFunction(what) {
    return typeof what === 'function';
}
export function isString(what) {
    return Object.prototype.toString.call(what) === '[object String]';
}
export function isArray(what) {
    return Object.prototype.toString.call(what) === '[object Array]';
}
export function isDate(what) {
    return Object.prototype.toString.call(what) === '[object Date]';
}
export function isUndefined(what) {
    return what === undefined;
}
export function isNull(what) {
    return what === null;
}
export function isNumber(what) {
    return typeof what === 'number';
}
export function isEmptyObject(what) {
    if (!isObject(what)) {
        return false;
    }
    for (var _1 in what) {
        // eslint-disable-next-line no-prototype-builtins
        if (what.hasOwnProperty(_1)) {
            return false;
        }
    }
    return true;
}
export function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMError]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
export function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
export function isErrorEvent(what) {
    return Object.prototype.toString.call(what) === '[object ErrorEvent]';
}
export function isPromiseRejectionEvent(what) {
    return Object.prototype.toString.call(what) === '[object PromiseRejectionEvent]';
}
//# sourceMappingURL=is.js.map